import { TemplatePage } from './types';

const musicPage: TemplatePage = {
  header: {
    color: '#EBB7B9',
    icon: 'images/video-templates/industry-music.jpg',
    title: 'Music Video Templates Collection',
    title_meta: '100+ Free Editable Music Video Templates',
    description_meta:
      'Create gripping music videos with Wave.video’s collection of 100+ stunning music video templates.',
    description:
      'Create gripping music videos with Wave.video’s collection of 100+ stunning music video templates. You can ' +
      'always customize these templates to your liking and make them look even more compelling and true to your brand.'
  },
  footer: {
    category: 'Music',
    description:
      'Wave.video’s diverse collection of attention-grabbing music video templates makes it simple to create compelling ' +
      'videos for any purpose. All the templates are free and easy to customize to suit every brand.'
  },
  content: [
    {
      type: 'templates',
      title: 'Music video templates',
      search: { name: 'music' }
    },
    {
      type: 'stocks',
      title: 'Music',
      search: { name: 'music' }
    },
    { type: 'calendar' }
  ]
} as TemplatePage;

export default musicPage;
